import { Entity } from '@backstage/catalog-model';
import { EntityTagFilter } from '@backstage/plugin-catalog-react';

/**
 * Hexagonal adapter over EntityTagFilter that applies OR logic.
 *
 * @remarks
 * EntityTagFilter uses .every() (AND): all selected tags must be present.
 * EntityTagOrFilter uses .some() (OR): any selected tag is sufficient.
 *
 * getCatalogFilters returns the tag values so that EntityAutocompletePicker
 * can populate its dropdown from the catalog API. The Backstage catalog API
 * treats multiple values for the same key as OR server-side, so this does not
 * introduce AND behaviour. Client-side OR logic is enforced by filterEntity.
 */
export class EntityTagOrFilter extends EntityTagFilter {
  filterEntity(entity: Entity): boolean {
    if (this.values.length === 0) {
      return true;
    }

    const entityTags = entity.metadata.tags ?? [];

    return this.values.some(value => entityTags.includes(value));
  }

  getCatalogFilters(): Record<string, string | string[]> {
    return this.values.length > 0 ? { 'metadata.tags': this.values } : {};
  }
}
